/**
 * Simple cache class to cache/memoize function values.
 */
export class CacheMap<Key, Value> {
  data: Map<Key, Value> = new Map();

  private constructor(private key: string) {
    this.key = key;
  }

  static create<Key, Value>(key: string) {
    return new CacheMap<Key, Value>(key);
  }

  get(key: Key): {or: (fn: () => Value) => Value} {
    return {
      or: (fn: () => Value) => {
        if (this.data.has(key)) return this.data.get(key)!;
        return this.set(key, fn());
      },
    };
  }

  set(key: Key, value: Value): Value {
    this.data.set(key, value);

    return value;
  }
}
